export default function BrandStory() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="lg:w-[40%]">
            <span className="inline-block px-3 py-1 bg-primary-50 text-primary-600 text-xs rounded-full mb-4 border border-primary-200/50">
              关于韩漫屋
            </span>
            <h1 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
              致力打造最好的
              <br />
              <strong className="text-primary-500">韩漫阅读</strong>平台
            </h1>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              韩漫屋成立于2024年，由一群热爱韩国漫画的年轻人创立。我们深知在浩瀚的漫画海洋中找到心仪作品的困难，因此立志打造一个专注于<strong>免费韩漫</strong>的高品质阅读平台。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              从最初收录数百部作品，到如今涵盖恋爱、奇幻、动作、悬疑等多种题材的<strong>漫画大全</strong>，我们始终坚持每日更新，为读者提供最新最热的<strong>好看韩国漫画</strong>。
            </p>
            <a href="#contact" className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer border-b border-primary-300">
              联系我们 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:w-[60%]">
            <div className="flex items-center gap-8 md:gap-12 justify-end mb-6">
              <div className="text-right">
                <div className="text-3xl md:text-5xl font-bold text-foreground-950">5000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">漫画作品</div>
              </div>
              <div className="text-right">
                <div className="text-3xl md:text-5xl font-bold text-foreground-950">200万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">日活读者</div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-[160px] md:w-[220px] aspect-[2/3] rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20platform%2C%20cozy%20modern%20office%20with%20comics%20display%2C%20warm%20lighting%2C%20creative%20atmosphere%2C%20clean%20minimal%20design%2C%20cream%20background&width=440&height=660&seq=about-brand-01&orientation=portrait"
                  alt="韩漫屋品牌形象"
                  title="韩漫屋 - 免费韩漫阅读平台"
                  className="w-full h-full object-cover object-top rounded-lg"
                  loading="lazy"
                />
              </div>
              <div className="w-[220px] md:w-[320px] aspect-[3/4] rounded-lg overflow-hidden flex-shrink-0 mt-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20collection%20on%20shelves%2C%20colorful%20comic%20books%2C%20organized%20display%2C%20warm%20inviting%20atmosphere%2C%20artistic%20composition%2C%20cream%20background&width=640&height=850&seq=about-brand-02&orientation=portrait"
                  alt="韩漫屋漫画收藏"
                  title="韩漫屋 - 海量漫画大全"
                  className="w-full h-full object-cover object-top rounded-lg"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}